import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { SimplePage } from '@cp-mx/common';
import { fetchLegalNotice } from './LegalNoticeSlice';
import { LegalNoticeContentSelector } from './LegalNoticeContentSelector';

export function useLegalNotice(): AbstractContentState<SimplePage> {
    return useCmsContent(fetchLegalNotice, LegalNoticeContentSelector);
}
